import React from 'react';
import { useTranslation } from 'react-i18next';
import { Container, Row, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';

const Pricing = () => {
    const { t } = useTranslation();
    const plans = [
        {
            name: t('pricing_plan1_name'),
            desc: t('pricing_plan1_desc'),
            price: '49',
            features: [
                t('pricing_plan1_feat1'),
                t('pricing_plan1_feat2'),
                t('pricing_plan1_feat3'),
                t('pricing_plan1_feat4'),
            ],
        },
        {
            name: t('pricing_plan2_name'),
            desc: t('pricing_plan2_desc'),
            price: '79',
            features: [
                t('pricing_plan2_feat1'),
                t('pricing_plan2_feat2'),
                t('pricing_plan2_feat3'),
                t('pricing_plan2_feat4'),
            ],
        },
        {
            name: t('pricing_plan3_name'),
            desc: t('pricing_plan3_desc'),
            price: '199',
            features: [
                t('pricing_plan3_feat1'),
                t('pricing_plan3_feat2'),
                t('pricing_plan3_feat3'),
                t('pricing_plan3_feat4'),
            ],
        },
    ];

    return (
        <section className="float-left w-100 position-relative pricing-plan-con padding-top padding-bottom main-box">
            <Container className="wow animate__animated animate__fadeInUp" data-wow-duration="2s" data-wow-delay="0.2s">
                <div className="heading-title-con text-center">
                    <span className="special-text color-blue d-block wow animate__animated animate__fadeInLeft" data-wow-duration="2s" data-wow-delay="0.4s">{t('pricing_title')}</span>
                    <h2 className="wow animate__animated animate__fadeInRight" data-wow-duration="2s" data-wow-delay="0.5s" dangerouslySetInnerHTML={{ __html: t('pricing_subtitle') }}></h2>
                </div>
                <Row className="all_row wow animate__animated animate__fadeInDown" data-wow-duration="2s" data-wow-delay="0.5s">
                    {plans.map((plan, index) => (
                        <Col lg={4} md={6} className="all_column" key={index}>
                            <div className="pricing-box w-100 all_boxes">
                                <div className="plan-content">
                                    <h3>{plan.name}</h3>
                                    <p>{plan.desc}</p>
                                    <div className="generic-price d-inline-block">
                                        <span className="d-block starting-at">{t('pricing_starting_at')}</span>
                                        <sup className="d-inline-block font-weight-normal">$</sup>
                                        <span className="d-inline-block price-text font-weight-600">{plan.price}</span>
                                        <span className="d-inline-block per-month mb-0 position-relative font-weight-normal">/mo</span>
                                    </div>
                                </div>
                                <div className="plan-listing">
                                    <ul className="list-unstyled p-0">
                                        {plan.features.map((feature, i) => (
                                            <li key={i} className="position-relative">
                                                <FontAwesomeIcon icon={faCheck} className="mr-2" />
                                                {feature}
                                            </li>
                                        ))}
                                    </ul>
                                    <a href="/pricing" className="text-decoration-none primary_btn">{t('banner_get_started')}</a>
                                </div>
                            </div>
                        </Col>
                    ))}
                </Row>
            </Container>
        </section>
    );
};

export default Pricing;